var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_vm._m(0),_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading"},[_vm._v(" Administrator Login ")]),_c('div',{staticClass:"panel-body"},[_c('LoginForm')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-wrapper"},[_c('img',{staticClass:"logo",attrs:{"alt":"Logo","src":require("@/assets/img/main_logo.svg")}})])
}]

export { render, staticRenderFns }